import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Toast from "../../../components/MessageToast";
import BreadCrumps from "../../../components/BreadCrups";
import CreateUserForm from "../../components/forms/UserCreateForm";
import apiService from "../../../services/apiService";
import { fetchUserData } from "../../../redux/users/index";

export default (props) => {
	const { userId } = props;
	const dispatch = useDispatch();

	const userData = useSelector((state) => state.user);
	const [state, setState] = useState({});

	useEffect(() => {
		if (userId && userId !== userData.data.id) {
			dispatch(fetchUserData(userId));
		}
	}, []);

	const handleFormSubmit = async (userData) => {
		setState((prev) => ({ ...prev, loading: true }));
		const response = await apiService({
			method: userId ? "PATCH" : "POST",
			path: userId ? `/api/users/${userId}` : "/api/users",
			data: userData,
		});
		Toast({
			duration: 5000,
			message: response.message,
			type: response.error ? "error" : "success",
			onClose: () => {
				setState((prev) => ({ ...prev, loading: false }));
				if (!response.error) {
					window.location.assign("/users");
				}
			},
		});
	};

	const crumps = [
		{
			title: "Users",
			path: "/users",
		},
	];

	return (
		<div>
			<BreadCrumps crumps={crumps} />
			<div>
				<CreateUserForm
					isCreate={true}
					title={userId ? "Update user" : "Create user"}
					onSubmit={handleFormSubmit}
					user={(userId && userData.data) || {}}
					loading={state.loading}
				/>
			</div>
		</div>
	);
};
